import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/tv_search.svg")